import {
  VOID3gxj6tk5isa35 as VOID,
  Unit_instance3vdlo4e4f5ggx as Unit_instance,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  Companion_getInstance4z8fvmvpott5 as Companion_getInstance,
  DurationUnit_MILLISECONDS_getInstancesewns20u1dyn as DurationUnit_MILLISECONDS_getInstance,
  toDuration7gy6v749ektt as toDuration,
  coerceIn10f36k81le1mm as coerceIn,
  copyOfRange3alro60z4hhf8 as copyOfRange,
  indexOfj0u699sj4o53 as indexOf,
  copyOfwy6h3t5vzqpl as copyOf,
  constructCallableReference23y65rf941mch as constructCallableReference,
  AutoCloseable1l5p57f9lp7kv as AutoCloseable,
  isInterface3d6p8outrmvmk as isInterface,
  _Char___init__impl__6a9atx2yltdocdrxs4d as _Char___init__impl__6a9atx,
  Char__toInt_impl_vasixd1ka89vowck9tn as Char__toInt_impl_vasixd,
  toByte4i43936u611k as toByte,
  fromInt1lka3ktyu79a4 as fromInt,
  add85si75olwt6n as add,
  subtract16cg4lfi29fq9 as subtract,
  Long2qws0ah9gnpki as Long,
  compare2uud5j30pw5xc as compare,
  coerceIn302bduskdb54x as coerceIn_0,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  convertToIntofdoxh9bstof as convertToInt,
  Paire9pteg33gng7 as Pair,
  divide3tol6kxdi8xn6 as divide,
  multiply18i3gv3wlmcjg as multiply,
  equalsLong28bsrfhwvd686 as equalsLong,
  modulo3mmbfwxzpcw3a as modulo,
  until1jbpn0z3f8lbg as until,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ClosedRangehokgr73im9z3 as ClosedRange,
  contains2c50nlxg7en7o as contains,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  createThis2j2avj17cvnv2 as createThis,
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
  RuntimeException1r3t0zl97011n as RuntimeException,
  toString30pk9tzaqopn as toString_0,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  printStackTrace18lnx7a39cni as printStackTrace,
  decodeToString1x4faah2liw2p as decodeToString,
} from './kotlin-kotlin-stdlib.mjs';
import {
  Channel3r72atmcithql as Channel,
  delayvyed5wvki0ic as delay,
  withContextqz5k6d9p9xx5 as withContext,
  CoroutineScopelux7s7zphw7e as CoroutineScope,
  launch1c91vkjzdi9sd as launch,
  Mutex16li1l0asjv17 as Mutex,
} from './kotlinx-coroutines-core.mjs';
import {
  ilog23dbvpk38jf7rc as ilog2,
  nextAlignedTo3ni8b2boh3zjg as nextAlignedTo,
  toIntClampad53d0g5q5oi as toIntClamp,
} from './korlibs-math-core-root-korlibs-math-core.mjs';
import {
  SimpleBytesDeque3uob1f4dosqej as SimpleBytesDeque,
  SimpleChunkedByteDeque3cr64mogfywgm as SimpleChunkedByteDeque,
  getS83kqgdtkseh4fp as getS8,
  getU83agrw8yj0shar as getU8,
  getS16BE6c2odqehs5au as getS16BE,
  getU16BE2rszf3doox5o as getU16BE,
  getU24BE36pml41y2814b as getU24BE,
  getS32BE5aphh7sm8f2q as getS32BE,
  getS64BE1b3e93qe1xjxx as getS64BE,
  getS8Array1clq6jd2z5jh9 as getS8Array,
  getS16ArrayBE3bj6gsad0tz3k as getS16ArrayBE,
  getU16ArrayBE1cpolqhg4wxps as getU16ArrayBE,
  getS32ArrayLE2u84ix7qnexrb as getS32ArrayLE,
  getS32ArrayBE30ehj217529qp as getS32ArrayBE,
  getS16LE39jsuv9u9gi4y as getS16LE,
  getS32LE1pxm9wohin3g8 as getS32LE,
  getU32LE1yo0ft9yyv0wa as getU32LE,
  getU16LE2cizldw8qp53x as getU16LE,
  arraycopy3czrd9re36wzt as arraycopy,
} from './korlibs-memory-root-korlibs-memory.mjs';
import {
  OutOfBoundsException1k0x58dcca6fx as OutOfBoundsException,
  Endian_LITTLE_ENDIAN_getInstance43td1z4hn3ua as Endian_LITTLE_ENDIAN_getInstance,
  ByteArrayBuilderyrflhqjz64ju as ByteArrayBuilder,
  EOFExceptiona2wwqnj55hh5 as EOFException,
  invalidOp1stebxh2m3n07 as invalidOp,
} from './korlibs-platform-root-korlibs-platform.mjs';
import {
  toString2x583ovdqfjci as toString_1,
  get_UTF82geyfhi1l22xl as get_UTF8,
} from './korlibs-string-root-korlibs-string.mjs';
import { Mixin3lmkm5hum2vdj as Mixin } from './korlibs-datastructure-core-root-korlibs-datastructure-core.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class AsyncOutputStream {}
function write$default(buffer, offset, len, $completion, $super) {
  offset = offset === VOID ? 0 : offset;
  len = len === VOID ? buffer.length - offset | 0 : len;
  return $super === VOID ? this.ib6(buffer, offset, len, $completion) : $super.ib6.call(this, buffer, offset, len, $completion);
}
class AsyncRingBuffer {
  constructor(bufferSize) {
    bufferSize = bufferSize === VOID ? 1024 : bufferSize;
    this.cb6_1 = bufferSize;
    this.db6_1 = null;
    this.eb6_1 = Channel(-1);
    this.fb6_1 = Channel(-1);
    this.gb6_1 = new SimpleBytesDeque(ilog2(this.cb6_1) + 1 | 0);
    this.hb6_1 = false;
  }
  *ib6(buffer, offset, len, $completion) {
    if (len <= 0)
      return Unit_instance;
    if (this.hb6_1) {
      // Inline function 'kotlin.error' call
      var message = 'Trying to write to a completed ' + this.toString();
      throw IllegalStateException.o(toString(message));
    }
    yield* this.eb6_1.n22($completion);
    this.gb6_1.aa1(buffer, offset, len);
    yield* this.fb6_1.j22(Unit_instance, $completion);
    return Unit_instance;
  }
  *kb6(buffer, offset, len, $completion) {
    if (len <= 0)
      return len;
    if (this.gb6_1.za0() > 0) {
      return this.gb6_1.ob3(buffer, offset, len);
    }
    yield* this.eb6_1.j22(Unit_instance, $completion);
    while (!this.hb6_1 && this.gb6_1.za0() === 0)
      yield* this.fb6_1.n22($completion);
    if (this.hb6_1 && this.gb6_1.za0() === 0)
      return -1;
    return this.gb6_1.ob3(buffer, offset, len);
  }
  *lb6($completion) {
    this.hb6_1 = true;
    yield* this.fb6_1.j22(Unit_instance, $completion);
    return Unit_instance;
  }
  toString() {
    return 'AsyncByteArrayDeque(' + this.db6_1 + ')';
  }
}
class Companion {
  constructor() {
    this.mb6_1 = 8388608;
  }
}
class AsyncRingBufferChunked {
  constructor(maxSize) {
    maxSize = maxSize === VOID ? 8388608 : maxSize;
    this.nb6_1 = maxSize;
    this.ob6_1 = null;
    this.pb6_1 = new SimpleChunkedByteDeque();
    this.qb6_1 = false;
  }
  *ib6(buffer, offset, len, $completion) {
    if (len <= 0)
      return Unit_instance;
    if (this.qb6_1) {
      // Inline function 'kotlin.error' call
      var message = 'Trying to write to a completed ' + this.toString();
      throw IllegalStateException.o(toString(message));
    }
    yield* /*#__NOINLINE__*/waitToWriteMore(this, len, $completion);
    this.pb6_1.p73(buffer, offset, len);
    return Unit_instance;
  }
  *kb6(buffer, offset, len, $completion) {
    if (len <= 0)
      return 0;
    if (offset < 0 || (offset + len | 0) > buffer.length)
      throw OutOfBoundsException.oaz();
    $l$loop: while (true) {
      var out = this.pb6_1.ob3(buffer, offset, len);
      if (out <= 0 && !this.qb6_1) {
        // Inline function 'kotlin.time.Companion.milliseconds' call
        Companion_getInstance();
        var tmp$ret$0 = toDuration(1, DurationUnit_MILLISECONDS_getInstance());
        yield* delay(tmp$ret$0, $completion);
        continue $l$loop;
      }
      return out;
    }
  }
  *lb6($completion) {
    this.qb6_1 = true;
    return Unit_instance;
  }
  toString() {
    return 'AsyncByteArrayDequeV2(' + this.ob6_1 + ')';
  }
}
class FastByteArrayInputStream {
  constructor(ba, offset, start, end) {
    offset = offset === VOID ? 0 : offset;
    start = start === VOID ? 0 : start;
    end = end === VOID ? ba.length : end;
    this.rb6_1 = ba;
    this.sb6_1 = start;
    this.tb6_1 = end;
    this.ub6_1 = offset + this.sb6_1 | 0;
  }
  vb6(value) {
    this.ub6_1 = this.sb6_1 + value | 0;
  }
  wb6() {
    return this.ub6_1 - this.sb6_1 | 0;
  }
  a() {
    return this.tb6_1 - this.sb6_1 | 0;
  }
  ab5() {
    return this.tb6_1 - this.ub6_1 | 0;
  }
  b6y() {
    return this.ab5() > 0;
  }
  xb6(_this__u8e3s4) {
    return coerceIn(_this__u8e3s4, this.sb6_1, this.tb6_1);
  }
  yb6(size) {
    var out = this.zb6(this.wb6(), size);
    this.ub6_1 = this.ub6_1 + size | 0;
    return out;
  }
  ab7(offset) {
    return new FastByteArrayInputStream(this.rb6_1, 0, this.xb6(this.sb6_1 + offset | 0), this.tb6_1);
  }
  bb7(offset, $super) {
    offset = offset === VOID ? 0 : offset;
    return $super === VOID ? this.ab7(offset) : $super.ab7.call(this, offset);
  }
  g9m() {
    return new FastByteArrayInputStream(this.rb6_1, this.wb6(), this.sb6_1, this.tb6_1);
  }
  zb6(offset, len) {
    return new FastByteArrayInputStream(this.rb6_1, 0, this.xb6(this.sb6_1 + offset | 0), this.xb6((this.sb6_1 + offset | 0) + len | 0));
  }
  kb5(count) {
    this.ub6_1 = coerceIn(this.ub6_1 + count | 0, this.sb6_1, this.tb6_1);
  }
  cb7(count) {
    return this.kb5(-count | 0);
  }
  db7(len) {
    var out = copyOfRange(this.rb6_1, this.ub6_1, this.ub6_1 + len | 0);
    this.ub6_1 = this.ub6_1 + len | 0;
    return out;
  }
  eb7() {
    return getS8(this.rb6_1, offset(this, 1));
  }
  fb7() {
    return getU8(this.rb6_1, offset(this, 1));
  }
  gb7() {
    return getS16BE(this.rb6_1, offset(this, 2));
  }
  hb7() {
    return getU16BE(this.rb6_1, offset(this, 2));
  }
  ib7() {
    return getU24BE(this.rb6_1, offset(this, 3));
  }
  jb7() {
    return getS32BE(this.rb6_1, offset(this, 4));
  }
  kb7() {
    return getS64BE(this.rb6_1, offset(this, 8));
  }
  lb7(count) {
    return getS8Array(this.rb6_1, offset(this, count), count);
  }
  mb7(count) {
    return getS16ArrayBE(this.rb6_1, offset(this, imul(count, 2)), count);
  }
  nb7(count) {
    return getU16ArrayBE(this.rb6_1, offset(this, imul(count, 2)), count);
  }
  ob7(count) {
    return getS32ArrayLE(this.rb6_1, offset(this, imul(count, 4)), count);
  }
  pb7(count) {
    return getS32ArrayBE(this.rb6_1, offset(this, imul(count, 4)), count);
  }
  qb7(offset, length, charset) {
    var start = this.sb6_1 + offset | 0;
    var end = start + length | 0;
    return toString_1(this.rb6_1, charset, start, end);
  }
  rb7(len, charset) {
    var res = this.lb7(len);
    var index = indexOf(res, 0);
    return toString_1(copyOf(res, index < 0 ? len : index), charset);
  }
  sb7(len, charset, $super) {
    charset = charset === VOID ? get_UTF8() : charset;
    return $super === VOID ? this.rb7(len, charset) : $super.rb7.call(this, len, charset);
  }
}
class AsyncGetLengthStream {}
function *hasLength($completion) {
  var tmp;
  try {
    tmp = compare(yield* this.pb8($completion), new Long(0, 0)) >= 0;
  } catch ($p) {
    var tmp_0;
    if ($p instanceof UnsupportedOperationException) {
      var t = $p;
      tmp_0 = false;
    } else {
      throw $p;
    }
    tmp = tmp_0;
  }
  return tmp;
}
function *getLength($completion) {
  throw UnsupportedOperationException.k9();
}
class AsyncStreamBase {
  static mb8($box) {
    return createThis(this, $box);
  }
  *nb8(position, buffer, offset, len, $completion) {
    throw UnsupportedOperationException.k9();
  }
  *ob8(position, buffer, offset, len, $completion) {
    throw UnsupportedOperationException.k9();
  }
  *pb8($completion) {
    throw UnsupportedOperationException.k9();
  }
  *lb6($completion) {
    return Unit_instance;
  }
}
class SyncAsyncStreamBase extends AsyncStreamBase {
  constructor(sync, dispatcher) {
    return new.target.hb8(sync, dispatcher);
  }
  static hb8(sync, dispatcher) {
    dispatcher = dispatcher === VOID ? null : dispatcher;
    var $this = this.mb8();
    $this.bb8_1 = sync;
    $this.cb8_1 = dispatcher;
    return $this;
  }
  *nb8(position, buffer, offset, len, $completion) {
    // Inline function 'korlibs.io.stream.SyncAsyncStreamBase.doIo' call
    var tmp;
    if (!(this.cb8_1 == null)) {
      tmp = yield* withContext(this.cb8_1, SyncAsyncStreamBase$read$slambda(this, position, buffer, offset, len), $completion);
    } else {
      tmp = this.bb8_1.kb8(position, buffer, offset, len);
    }
    return tmp;
  }
  *ob8(position, buffer, offset, len, $completion) {
    // Inline function 'korlibs.io.stream.SyncAsyncStreamBase.doIo' call
    if (!(this.cb8_1 == null)) {
      yield* withContext(this.cb8_1, SyncAsyncStreamBase$write$slambda(this, position, buffer, offset, len), $completion);
    } else {
      this.bb8_1.lb8(position, buffer, offset, len);
    }
    return Unit_instance;
  }
  *pb8($completion) {
    // Inline function 'korlibs.io.stream.SyncAsyncStreamBase.doIo' call
    var tmp;
    if (!(this.cb8_1 == null)) {
      tmp = yield* withContext(this.cb8_1, SyncAsyncStreamBase$getLength$slambda(this), $completion);
    } else {
      tmp = this.bb8_1.a();
    }
    return tmp;
  }
}
class AsyncGetPositionStream {}
function *getPosition($completion) {
  throw UnsupportedOperationException.k9();
}
class toAsync$1 {
  constructor($this_toAsync, $dispatcher) {
    this.sb8_1 = $dispatcher;
    this.rb8_1 = $this_toAsync;
  }
  *kb6(buffer, offset, len, $completion) {
    // Inline function 'korlibs.io.stream.<no name provided>.doIo' call
    // Inline function 'korlibs.io.stream.doIo' call
    var dispatcher = this.sb8_1;
    var tmp;
    if (!(dispatcher == null)) {
      tmp = yield* withContext(dispatcher, toAsync$o$read$slambda(this, buffer, offset, len), $completion);
    } else {
      tmp = this.rb8_1.ob3(buffer, offset, len);
    }
    return tmp;
  }
  *lb6($completion) {
    // Inline function 'korlibs.io.stream.launchIo' call
    var dispatcher = this.sb8_1;
    if (!(dispatcher == null)) {
      var tmp = CoroutineScope(dispatcher);
      launch(tmp, VOID, VOID, toAsync$o$close$slambda(this));
    } else {
      var tmp_0 = this.rb8_1;
      var tmp4_safe_receiver = isInterface(tmp_0, AutoCloseable) ? tmp_0 : null;
      if (tmp4_safe_receiver == null)
        null;
      else {
        tmp4_safe_receiver.f7();
      }
    }
    return Unit_instance;
  }
  *tb8($completion) {
    // Inline function 'korlibs.io.stream.<no name provided>.doIo' call
    // Inline function 'korlibs.io.stream.doIo' call
    var dispatcher = this.sb8_1;
    var tmp;
    if (!(dispatcher == null)) {
      tmp = yield* withContext(dispatcher, toAsync$o$getPosition$slambda(this), $completion);
    } else {
      var tmp_0 = this.rb8_1;
      var tmp5_safe_receiver = isInterface(tmp_0, SyncPositionStream) ? tmp_0 : null;
      tmp = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.wb6();
    }
    var tmp0_elvis_lhs = tmp;
    return tmp0_elvis_lhs == null ? (yield* getPosition.call(this, $completion)) : tmp0_elvis_lhs;
  }
  *pb8($completion) {
    // Inline function 'korlibs.io.stream.<no name provided>.doIo' call
    // Inline function 'korlibs.io.stream.doIo' call
    var dispatcher = this.sb8_1;
    var tmp;
    if (!(dispatcher == null)) {
      tmp = yield* withContext(dispatcher, toAsync$o$getLength$slambda(this), $completion);
    } else {
      var tmp_0 = this.rb8_1;
      var tmp6_safe_receiver = isInterface(tmp_0, SyncLengthStream) ? tmp_0 : null;
      tmp = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.a();
    }
    var tmp0_elvis_lhs = tmp;
    return tmp0_elvis_lhs == null ? (yield* getLength.call(this, $completion)) : tmp0_elvis_lhs;
  }
}
class toAsync$2 {
  constructor($this_toAsync, $dispatcher) {
    this.vb8_1 = $dispatcher;
    this.ub8_1 = $this_toAsync;
  }
  *ib6(buffer, offset, len, $completion) {
    // Inline function 'korlibs.io.stream.<no name provided>.doIo' call
    // Inline function 'korlibs.io.stream.doIo' call
    var dispatcher = this.vb8_1;
    var tmp;
    if (!(dispatcher == null)) {
      tmp = yield* withContext(dispatcher, toAsync$o$write$slambda(this, buffer, offset, len), $completion);
    } else {
      this.ub8_1.p73(buffer, offset, len);
      tmp = Unit_instance;
    }
    return Unit_instance;
  }
  *lb6($completion) {
    // Inline function 'korlibs.io.stream.launchIo' call
    var dispatcher = this.vb8_1;
    if (!(dispatcher == null)) {
      var tmp = CoroutineScope(dispatcher);
      launch(tmp, VOID, VOID, toAsync$o$close$slambda_0(this));
    } else {
      var tmp_0 = this.ub8_1;
      var tmp7_safe_receiver = isInterface(tmp_0, AutoCloseable) ? tmp_0 : null;
      if (tmp7_safe_receiver == null)
        null;
      else {
        tmp7_safe_receiver.f7();
      }
    }
    return Unit_instance;
  }
}
class SliceAsyncStreamBase extends AsyncStreamBase {
  constructor(base, baseStart, baseEnd, closeParent) {
    return new.target.ib9(base, baseStart, baseEnd, closeParent);
  }
  static ib9(base, baseStart, baseEnd, closeParent) {
    var $this = this.mb8();
    $this.db9_1 = base;
    $this.eb9_1 = baseStart;
    $this.fb9_1 = baseEnd;
    $this.gb9_1 = closeParent;
    $this.hb9_1 = subtract($this.fb9_1, $this.eb9_1);
    return $this;
  }
  *nb8(position, buffer, offset, len, $completion) {
    var _destruct__k2r9zo = clampPositionLen(this, position, len);
    var targetStartPosition = _destruct__k2r9zo.jm();
    var targetLen = _destruct__k2r9zo.km();
    return yield* this.db9_1.nb8(targetStartPosition, buffer, offset, targetLen, $completion);
  }
  *ob8(position, buffer, offset, len, $completion) {
    var _destruct__k2r9zo = clampPositionLen(this, position, len);
    var targetStartPosition = _destruct__k2r9zo.jm();
    var targetLen = _destruct__k2r9zo.km();
    return yield* this.db9_1.ob8(targetStartPosition, buffer, offset, targetLen, $completion);
  }
  *pb8($completion) {
    return this.hb9_1;
  }
  *lb6($completion) {
    if (this.gb9_1) {
      yield* this.db9_1.lb6($completion);
    }
    return Unit_instance;
  }
  toString() {
    return 'SliceAsyncStreamBase(' + toString(this.db9_1) + ', ' + this.eb9_1.toString() + ', ' + this.fb9_1.toString() + ')';
  }
}
class BufferedStreamBase extends AsyncStreamBase {
  constructor(base, blockSize, blocksToRead) {
    return new.target.pb9(base, blockSize, blocksToRead);
  }
  static pb9(base, blockSize, blocksToRead) {
    blockSize = blockSize === VOID ? 2048 : blockSize;
    blocksToRead = blocksToRead === VOID ? 16 : blocksToRead;
    var $this = this.mb8();
    $this.jb9_1 = base;
    $this.kb9_1 = blockSize;
    $this.lb9_1 = blocksToRead;
    $this.mb9_1 = imul($this.kb9_1, $this.lb9_1);
    var tmp = $this;
    // Inline function 'kotlin.byteArrayOf' call
    tmp.nb9_1 = new Int8Array([]);
    $this.ob9_1 = new Long(-1, -1);
    return $this;
  }
  *nb8(position, buffer, offset, len, $completion) {
    return yield* this.qb9(position, buffer, offset, len, $completion);
  }
  toString() {
    return 'Buffered[' + this.lb9_1 + '*' + this.kb9_1 + ']:' + toString(this.jb9_1);
  }
  *qb9(position, buffer, offset, len, $completion) {
    if ((yield* this.jb9_1.qb8($completion)) && compare(position, yield* this.jb9_1.pb8($completion)) >= 0)
      return -1;
    // Inline function 'kotlin.Long.div' call
    var other = this.mb9_1;
    var sector = divide(position, fromInt(other));
    if (!equalsLong(this.ob9_1, sector)) {
      // Inline function 'kotlin.Long.times' call
      var other_0 = this.mb9_1;
      var pos = multiply(sector, fromInt(other_0));
      var tmp;
      if (yield* this.jb9_1.qb8($completion)) {
        var tmp0 = fromInt(this.mb9_1);
        // Inline function 'kotlin.comparisons.minOf' call
        var b = subtract(yield* this.jb9_1.pb8($completion), pos);
        var tmp$ret$2 = compare(tmp0, b) <= 0 ? tmp0 : b;
        tmp = convertToInt(tmp$ret$2);
      } else {
        tmp = this.mb9_1;
      }
      var len_0 = tmp;
      this.nb9_1 = yield* readBytes(this.jb9_1, pos, len_0, $completion);
      this.ob9_1 = sector;
    }
    // Inline function 'kotlin.Long.rem' call
    var other_1 = this.mb9_1;
    var tmp$ret$3 = modulo(position, fromInt(other_1));
    var soffset = convertToInt(tmp$ret$3);
    var available = this.nb9_1.length - soffset | 0;
    // Inline function 'kotlin.math.min' call
    var toRead = Math.min(available, len);
    arraycopy(this.nb9_1, soffset, buffer, offset, toRead);
    return toRead;
  }
  *ob8(position, buffer, offset, len, $completion) {
    yield* this.jb9_1.ob8(position, buffer, offset, len, $completion);
    return Unit_instance;
  }
  *pb8($completion) {
    return yield* this.jb9_1.pb8($completion);
  }
  *lb6($completion) {
    return yield* this.jb9_1.lb6($completion);
  }
}
class MemoryAsyncStreamBase extends AsyncStreamBase {
  constructor(data) {
    return new.target.ib8(data);
  }
  static ib8(data) {
    var $this = this.mb8();
    $this.db8_1 = data;
    return $this;
  }
  static rb9(initialCapacity) {
    initialCapacity = initialCapacity === VOID ? 4096 : initialCapacity;
    return this.ib8(ByteArrayBuilder.taz(initialCapacity));
  }
  sb9() {
    return this.db8_1.s2();
  }
  *pb8($completion) {
    return fromInt(this.sb9());
  }
  tb9(position) {
    if (compare(position, new Long(0, 0)) < 0)
      throw IllegalArgumentException.h2('Invalid position ' + position.toString());
  }
  *nb8(position, buffer, offset, len, $completion) {
    this.tb9(position);
    // Inline function 'kotlin.ranges.contains' call
    var this_0 = until(0, this.sb9());
    if (!contains(isInterface(this_0, ClosedRange) ? this_0 : THROW_CCE(), position))
      return 0;
    var tmp0 = fromInt(this.sb9());
    // Inline function 'kotlin.Long.plus' call
    // Inline function 'kotlin.math.min' call
    var b = add(position, fromInt(len));
    var end = compare(tmp0, b) <= 0 ? tmp0 : b;
    // Inline function 'kotlin.math.max' call
    var a = convertToInt(subtract(end, position));
    var actualLen = Math.max(a, 0);
    arraycopy(this.db8_1.paz_1, convertToInt(position), buffer, offset, actualLen);
    return actualLen;
  }
  *ob8(position, buffer, offset, len, $completion) {
    this.tb9(position);
    var tmp = this.db8_1;
    var tmp0 = this.db8_1.s2();
    // Inline function 'kotlin.Long.plus' call
    var tmp$ret$0 = add(position, fromInt(len));
    // Inline function 'kotlin.math.max' call
    var b = convertToInt(tmp$ret$0);
    var tmp$ret$1 = Math.max(tmp0, b);
    tmp.aa2(tmp$ret$1);
    arraycopy(buffer, offset, this.db8_1.paz_1, convertToInt(position), len);
    return Unit_instance;
  }
  *lb6($completion) {
    return Unit_instance;
  }
  toString() {
    return 'MemoryAsyncStreamBase(' + this.db8_1.s2() + ')';
  }
}
class AsyncPositionLengthStream {}
function *hasAvailable($completion) {
  return yield* this.qb8($completion);
}
function *getAvailable($completion) {
  return subtract(yield* this.pb8($completion), yield* this.tb8($completion));
}
function *eof($completion) {
  return (yield* this.vb9($completion)) && compare(yield* this.wb9($completion), new Long(0, 0)) <= 0;
}
class AsyncStream {
  constructor(base, position, queue) {
    position = position === VOID ? new Long(0, 0) : position;
    queue = queue === VOID ? false : queue;
    this.wb8_1 = new Mixin();
    this.xb8_1 = base;
    this.yb8_1 = position;
    this.zb8_1 = queue;
    this.ab9_1 = Mutex();
    this.bb9_1 = Mutex();
  }
  o9u(_set____db54di) {
    this.wb8_1.o9u(_set____db54di);
  }
  p9u() {
    return this.wb8_1.p9u();
  }
  toString() {
    return 'AsyncStream(' + toString(this.xb8_1) + ', position=' + this.yb8_1.toString() + ')';
  }
  *kb6(buffer, offset, len, $completion) {
    var tmp;
    if (this.zb8_1) {
      // Inline function 'kotlinx.coroutines.sync.withLock' call
      var this_0 = this.ab9_1;
      yield* this_0.y2a(null, $completion);
      var tmp_0;
      try {
        tmp_0 = yield* /*#__NOINLINE__*/readInternal(this, buffer, offset, len, $completion);
      }finally {
        this_0.k2a(null);
      }
      tmp = tmp_0;
    } else {
      tmp = yield* /*#__NOINLINE__*/readInternal(this, buffer, offset, len, $completion);
    }
    return tmp;
  }
  *ib6(buffer, offset, len, $completion) {
    if (this.zb8_1) {
      // Inline function 'kotlinx.coroutines.sync.withLock' call
      var this_0 = this.bb9_1;
      yield* this_0.y2a(null, $completion);
      try {
        yield* /*#__NOINLINE__*/writeInternal(this, buffer, offset, len, $completion);
      }finally {
        this_0.k2a(null);
      }
    } else
      yield* /*#__NOINLINE__*/writeInternal(this, buffer, offset, len, $completion);
    return Unit_instance;
  }
  *qb8($completion) {
    return yield* this.xb8_1.qb8($completion);
  }
  *cb9(value, $completion) {
    this.yb8_1 = value;
    return Unit_instance;
  }
  *tb8($completion) {
    return this.yb8_1;
  }
  *pb8($completion) {
    return yield* this.xb8_1.pb8($completion);
  }
  *lb6($completion) {
    return yield* this.xb8_1.lb6($completion);
  }
  ub9() {
    return new AsyncStream(this.xb8_1, this.yb8_1);
  }
}
class asyncStreamWriter$2$ensureJob$2$1 {
  constructor(this$0) {
    this.dba_1 = this$0;
  }
  *ib6(buffer, offset, len, $completion) {
    return yield* this.dba_1.yb9_1.ib6(buffer, offset, len, $completion);
  }
  *lb6($completion) {
    return yield* this.dba_1.yb9_1.lb6($completion);
  }
}
class asyncStreamWriter$2 {
  constructor($lazy, $bufferSize, $name, $process) {
    this.cba_1 = $process;
    var tmp = this;
    var tmp_0;
    if ($lazy) {
      // Inline function 'kotlin.also' call
      var this_0 = new AsyncRingBuffer($bufferSize);
      this_0.db6_1 = $name;
      tmp_0 = this_0;
    } else {
      // Inline function 'kotlin.also' call
      var this_1 = new AsyncRingBufferChunked($bufferSize);
      this_1.ob6_1 = $name;
      tmp_0 = this_1;
    }
    tmp.yb9_1 = tmp_0;
    this.zb9_1 = null;
    this.aba_1 = null;
    this.bba_1 = new Int8Array(1);
  }
  *kb6(buffer, offset, len, $completion) {
    yield* /*#__NOINLINE__*/ensureJob(this, $completion);
    checkException(this);
    // Inline function 'kotlin.also' call
    return yield* this.yb9_1.kb6(buffer, offset, len, $completion);
  }
  *lb6($completion) {
    var tmp14_safe_receiver = this.aba_1;
    if (tmp14_safe_receiver == null)
      null;
    else {
      tmp14_safe_receiver.o1n();
    }
    this.aba_1 = null;
    return Unit_instance;
  }
}
class SyncLengthStream {}
class SyncStreamBase {
  static kba() {
    var $this = createThis(this);
    $this.jb8_1 = new Int8Array(16);
    return $this;
  }
  lba() {
    return false;
  }
  kb8(position, buffer, offset, len) {
    throw UnsupportedOperationException.k9();
  }
  lb8(position, buffer, offset, len) {
    throw UnsupportedOperationException.k9();
  }
  a() {
    throw UnsupportedOperationException.k9();
  }
  f7() {
    return Unit_instance;
  }
  mba(position) {
    return new SyncStream(this, position);
  }
  jba(position, $super) {
    position = position === VOID ? new Long(0, 0) : position;
    return $super === VOID ? this.mba(position) : $super.mba.call(this, position);
  }
  nba(position) {
    return new SyncStream(this, position);
  }
  oba(position, $super) {
    position = position === VOID ? new Long(0, 0) : position;
    return $super === VOID ? this.nba(position) : $super.nba.call(this, position);
  }
}
class ReadonlySyncStreamBase extends SyncStreamBase {
  constructor(data, offset, size) {
    return new.target.iba(data, offset, size);
  }
  static iba(data, offset, size) {
    offset = offset === VOID ? 0 : offset;
    size = size === VOID ? data.length - offset | 0 : size;
    var $this = this.kba();
    $this.fba_1 = data;
    $this.gba_1 = offset;
    $this.hba_1 = size;
    return $this;
  }
  sb9() {
    return this.hba_1;
  }
  a() {
    return fromInt(this.fba_1.length);
  }
  tb9(position) {
    if (compare(position, new Long(0, 0)) < 0) {
      invalidOp('Invalid position ' + position.toString());
    }
  }
  kb8(position, buffer, offset, len) {
    this.tb9(position);
    var ipos = convertToInt(position);
    // Inline function 'kotlin.ranges.contains' call
    var this_0 = until(0, this.sb9());
    if (!contains(isInterface(this_0, ClosedRange) ? this_0 : THROW_CCE(), position))
      return 0;
    var tmp0 = this.sb9();
    // Inline function 'kotlin.math.min' call
    var b = ipos + len | 0;
    var end = Math.min(tmp0, b);
    // Inline function 'kotlin.math.max' call
    var a = end - ipos | 0;
    var actualLen = Math.max(a, 0);
    arraycopy(this.fba_1, ipos + this.gba_1 | 0, buffer, offset, actualLen);
    return actualLen;
  }
  f7() {
    return Unit_instance;
  }
  toString() {
    return 'ReadonlySyncStreamBase(' + this.fba_1.length + ')';
  }
}
class MemorySyncStreamBase extends SyncStreamBase {
  constructor(data) {
    return new.target.gb8(data);
  }
  static gb8(data) {
    var $this = this.kba();
    $this.fb8_1 = data;
    return $this;
  }
  static pba(initialCapacity) {
    initialCapacity = initialCapacity === VOID ? 4096 : initialCapacity;
    return this.gb8(ByteArrayBuilder.taz(initialCapacity));
  }
  sb9() {
    return this.fb8_1.s2();
  }
  a() {
    return fromInt(this.fb8_1.s2());
  }
  tb9(position) {
    if (compare(position, new Long(0, 0)) < 0)
      throw IllegalArgumentException.h2('Invalid position ' + position.toString());
  }
  kb8(position, buffer, offset, len) {
    this.tb9(position);
    var ipos = convertToInt(position);
    // Inline function 'kotlin.ranges.contains' call
    var this_0 = until(0, this.sb9());
    if (!contains(isInterface(this_0, ClosedRange) ? this_0 : THROW_CCE(), position))
      return 0;
    var tmp0 = this.sb9();
    // Inline function 'kotlin.math.min' call
    var b = ipos + len | 0;
    var end = Math.min(tmp0, b);
    // Inline function 'kotlin.math.max' call
    var a = end - ipos | 0;
    var actualLen = Math.max(a, 0);
    arraycopy(this.fb8_1.paz_1, ipos, buffer, offset, actualLen);
    return actualLen;
  }
  lb8(position, buffer, offset, len) {
    this.tb9(position);
    var tmp = this.fb8_1;
    var tmp0 = this.fb8_1.s2();
    // Inline function 'kotlin.Long.plus' call
    var tmp$ret$0 = add(position, fromInt(len));
    // Inline function 'kotlin.math.max' call
    var b = convertToInt(tmp$ret$0);
    var tmp$ret$1 = Math.max(tmp0, b);
    tmp.aa2(tmp$ret$1);
    arraycopy(buffer, offset, this.fb8_1.paz_1, convertToInt(position), len);
  }
  f7() {
    return Unit_instance;
  }
  toString() {
    return 'MemorySyncStreamBase(' + this.fb8_1.s2() + ')';
  }
}
class SyncInputStream {}
function read() {
  // Inline function 'kotlin.let' call
  var it = new Int8Array(1);
  return this.ob3(it, 0, 1) > 0 ? it[0] & 255 : -1;
}
class SyncPositionStream {}
class SyncOutputStream {}
function write(byte) {
  // Inline function 'kotlin.let' call
  var it = new Int8Array(1);
  it[0] = toByte(byte);
  this.p73(it, 0, 1);
  return Unit_instance;
}
class SyncStream {
  constructor(base, position) {
    position = position === VOID ? new Long(0, 0) : position;
    this.tb7_1 = new Mixin();
    this.ub7_1 = base;
    this.vb7_1 = this.ub7_1.jb8_1;
    this.wb7_1 = this.ub7_1.lba();
    this.xb7_1 = position;
    this.yb7_1 = position;
    this.zb7_1 = position;
    this.ab8_1 = new Long(0, 0);
  }
  o9u(_set____db54di) {
    this.tb7_1.o9u(_set____db54di);
  }
  p9u() {
    return this.tb7_1.p9u();
  }
  qba(value) {
    if (this.wb7_1)
      this.xb7_1 = value;
    else {
      this.rba(value);
    }
  }
  sba() {
    return this.wb7_1 ? this.xb7_1 : this.wb6();
  }
  tba(value) {
    if (this.wb7_1)
      this.yb7_1 = value;
    else {
      this.rba(value);
    }
  }
  uba() {
    return this.wb7_1 ? this.yb7_1 : this.wb6();
  }
  rba(value) {
    var tmp;
    if (this.wb7_1) {
      this.qba(value);
      tmp = Unit_instance;
    } else {
      this.zb7_1 = value;
      tmp = Unit_instance;
    }
    return tmp;
  }
  wb6() {
    return this.wb7_1 ? this.sba() : this.zb7_1;
  }
  ob3(buffer, offset, len) {
    var read = this.ub7_1.kb8(this.sba(), buffer, offset, len);
    // Inline function 'kotlin.Long.plus' call
    var this_0 = this.sba();
    var tmp$ret$0 = add(this_0, fromInt(read));
    this.qba(tmp$ret$0);
    return read;
  }
  k2k() {
    var size = this.ob3(this.vb7_1, 0, 1);
    if (size <= 0)
      return -1;
    return this.vb7_1[0] & 255;
  }
  p73(buffer, offset, len) {
    this.ub7_1.lb8(this.uba(), buffer, offset, len);
    // Inline function 'kotlin.Long.plus' call
    var this_0 = this.uba();
    var tmp$ret$0 = add(this_0, fromInt(len));
    this.tba(tmp$ret$0);
  }
  vba(byte) {
    this.vb7_1[0] = toByte(byte);
    this.p73(this.vb7_1, 0, 1);
  }
  a() {
    return this.ub7_1.a();
  }
  f7() {
    return this.ub7_1.f7();
  }
  za0() {
    return subtract(this.a(), this.sba());
  }
  ab5() {
    return this.za0();
  }
  toString() {
    return 'SyncStream(' + toString(this.ub7_1) + ', ' + this.wb6().toString() + ')';
  }
}
class SliceSyncStreamBase extends SyncStreamBase {
  constructor(base, baseStart, baseEnd) {
    return new.target.bbb(base, baseStart, baseEnd);
  }
  static bbb(base, baseStart, baseEnd) {
    var $this = this.kba();
    $this.xba_1 = base;
    $this.yba_1 = baseStart;
    $this.zba_1 = baseEnd;
    $this.abb_1 = subtract($this.zba_1, $this.yba_1);
    return $this;
  }
  lba() {
    return this.xba_1.lba();
  }
  a() {
    return this.abb_1;
  }
  kb8(position, buffer, offset, len) {
    var _destruct__k2r9zo = clampPositionLen_0(this, position, len);
    var targetStartPosition = _destruct__k2r9zo.jm();
    var targetLen = _destruct__k2r9zo.km();
    return this.xba_1.kb8(targetStartPosition, buffer, offset, targetLen);
  }
  lb8(position, buffer, offset, len) {
    var _destruct__k2r9zo = clampPositionLen_0(this, position, len);
    var targetStartPosition = _destruct__k2r9zo.jm();
    var targetLen = _destruct__k2r9zo.km();
    return this.xba_1.lb8(targetStartPosition, buffer, offset, targetLen);
  }
  f7() {
    return Unit_instance;
  }
  toString() {
    return 'SliceAsyncStreamBase(' + toString(this.xba_1) + ', ' + this.yba_1.toString() + ', ' + this.zba_1.toString() + ')';
  }
}
//endregion
var Companion_instance;
function Companion_getInstance_0() {
  return Companion_instance;
}
function *waitToWriteMore($this, len, $completion) {
  if ($this.pb6_1.rb3_1 > $this.nb6_1) {
    while ($this.pb6_1.rb3_1 > (1 + ($this.nb6_1 / 2 | 0) | 0)) {
      // Inline function 'kotlin.time.Companion.milliseconds' call
      Companion_getInstance();
      var tmp$ret$0 = toDuration(1, DurationUnit_MILLISECONDS_getInstance());
      yield* delay(tmp$ret$0, $completion);
    }
  }
  return Unit_instance;
}
function offset($this, count) {
  var out = $this.ub6_1;
  $this.ub6_1 = $this.ub6_1 + count | 0;
  return out;
}
function openFastStream(_this__u8e3s4, offset) {
  offset = offset === VOID ? 0 : offset;
  return new FastByteArrayInputStream(_this__u8e3s4, offset);
}
function get_EMPTY_BYTE_ARRAY() {
  _init_properties_SyncAsync_ext_kt__inwu1q();
  return EMPTY_BYTE_ARRAY;
}
var EMPTY_BYTE_ARRAY;
function toAsync(_this__u8e3s4, dispatcher) {
  dispatcher = dispatcher === VOID ? null : dispatcher;
  _init_properties_SyncAsync_ext_kt__inwu1q();
  return toAsyncStream(toAsync_2(_this__u8e3s4.ub7_1, dispatcher), _this__u8e3s4.wb6());
}
function toSyncOrNull(_this__u8e3s4) {
  _init_properties_SyncAsync_ext_kt__inwu1q();
  var tmp0_safe_receiver = _this__u8e3s4 instanceof SyncAsyncStreamBase ? _this__u8e3s4 : null;
  var tmp0_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.bb8_1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    var tmp1_safe_receiver = _this__u8e3s4 instanceof MemoryAsyncStreamBase ? _this__u8e3s4 : null;
    var tmp_0;
    if (tmp1_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_0 = MemorySyncStreamBase.gb8(tmp1_safe_receiver.db8_1);
    }
    tmp = tmp_0;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function toAsync_0(_this__u8e3s4, dispatcher) {
  dispatcher = dispatcher === VOID ? null : dispatcher;
  _init_properties_SyncAsync_ext_kt__inwu1q();
  return new toAsync$1(_this__u8e3s4, dispatcher);
}
function toAsync_1(_this__u8e3s4, dispatcher) {
  dispatcher = dispatcher === VOID ? null : dispatcher;
  _init_properties_SyncAsync_ext_kt__inwu1q();
  return new toAsync$2(_this__u8e3s4, dispatcher);
}
function toAsync_2(_this__u8e3s4, dispatcher) {
  dispatcher = dispatcher === VOID ? null : dispatcher;
  _init_properties_SyncAsync_ext_kt__inwu1q();
  var tmp;
  if (_this__u8e3s4 instanceof MemorySyncStreamBase) {
    tmp = MemoryAsyncStreamBase.ib8(_this__u8e3s4.fb8_1);
  } else {
    tmp = SyncAsyncStreamBase.hb8(_this__u8e3s4, dispatcher);
  }
  return tmp;
}
function SyncAsyncStreamBase$read$slambda(this$0, $position, $buffer, $offset, $len) {
  return constructCallableReference(function *($this$withContext, $completion) {
    return this$0.bb8_1.kb8($position, $buffer, $offset, $len);
  }, 1);
}
function SyncAsyncStreamBase$write$slambda(this$0, $position, $buffer, $offset, $len) {
  return constructCallableReference(function *($this$withContext, $completion) {
    this$0.bb8_1.lb8($position, $buffer, $offset, $len);
    return Unit_instance;
  }, 1);
}
function SyncAsyncStreamBase$getLength$slambda(this$0) {
  return constructCallableReference(function *($this$withContext, $completion) {
    return this$0.bb8_1.a();
  }, 1);
}
function toAsync$o$read$slambda(this$0, $buffer, $offset, $len) {
  return constructCallableReference(function *($this$withContext, $completion) {
    return this$0.rb8_1.ob3($buffer, $offset, $len);
  }, 1);
}
function toAsync$o$close$slambda(this$0) {
  return constructCallableReference(function *($this$launch, $completion) {
    var tmp = this$0.rb8_1;
    var tmp4_safe_receiver = isInterface(tmp, AutoCloseable) ? tmp : null;
    if (tmp4_safe_receiver == null)
      null;
    else {
      tmp4_safe_receiver.f7();
    }
    return Unit_instance;
  }, 1);
}
function toAsync$o$getPosition$slambda(this$0) {
  return constructCallableReference(function *($this$withContext, $completion) {
    var tmp = this$0.rb8_1;
    var tmp5_safe_receiver = isInterface(tmp, SyncPositionStream) ? tmp : null;
    return tmp5_safe_receiver == null ? null : tmp5_safe_receiver.wb6();
  }, 1);
}
function toAsync$o$getLength$slambda(this$0) {
  return constructCallableReference(function *($this$withContext, $completion) {
    var tmp = this$0.rb8_1;
    var tmp6_safe_receiver = isInterface(tmp, SyncLengthStream) ? tmp : null;
    return tmp6_safe_receiver == null ? null : tmp6_safe_receiver.a();
  }, 1);
}
function toAsync$o$write$slambda(this$0, $buffer, $offset, $len) {
  return constructCallableReference(function *($this$withContext, $completion) {
    this$0.ub8_1.p73($buffer, $offset, $len);
    return Unit_instance;
  }, 1);
}
function toAsync$o$close$slambda_0(this$0) {
  return constructCallableReference(function *($this$launch, $completion) {
    var tmp = this$0.ub8_1;
    var tmp7_safe_receiver = isInterface(tmp, AutoCloseable) ? tmp : null;
    if (tmp7_safe_receiver == null)
      null;
    else {
      tmp7_safe_receiver.f7();
    }
    return Unit_instance;
  }, 1);
}
var properties_initialized_SyncAsync_ext_kt_cwobuk;
function _init_properties_SyncAsync_ext_kt__inwu1q() {
  if (!properties_initialized_SyncAsync_ext_kt_cwobuk) {
    properties_initialized_SyncAsync_ext_kt_cwobuk = true;
    EMPTY_BYTE_ARRAY = new Int8Array(0);
  }
}
function *readS16LE(_this__u8e3s4, $completion) {
  // Inline function 'korlibs.io.stream.readSmallTempExact' call
  var it = new Int8Array(2);
  var read = yield* _this__u8e3s4.kb6(it, 0, 2, $completion);
  if (!(read === 2)) {
    // Inline function 'kotlin.error' call
    var message = "Couldn't read exact size=" + 2 + ' but read=' + read;
    throw IllegalStateException.o(toString(message));
  }
  return getS16LE(it, 0);
}
function *readS32LE(_this__u8e3s4, $completion) {
  // Inline function 'korlibs.io.stream.readSmallTempExact' call
  var it = new Int8Array(4);
  var read = yield* _this__u8e3s4.kb6(it, 0, 4, $completion);
  if (!(read === 4)) {
    // Inline function 'kotlin.error' call
    var message = "Couldn't read exact size=" + 4 + ' but read=' + read;
    throw IllegalStateException.o(toString(message));
  }
  return getS32LE(it, 0);
}
function *readU32LE(_this__u8e3s4, $completion) {
  // Inline function 'korlibs.io.stream.readSmallTempExact' call
  var it = new Int8Array(4);
  var read = yield* _this__u8e3s4.kb6(it, 0, 4, $completion);
  if (!(read === 4)) {
    // Inline function 'kotlin.error' call
    var message = "Couldn't read exact size=" + 4 + ' but read=' + read;
    throw IllegalStateException.o(toString(message));
  }
  return getU32LE(it, 0);
}
function *readString(_this__u8e3s4, len, charset, $completion) {
  charset = charset === VOID ? get_UTF8() : charset;
  return toString_1(yield* readBytesExact(_this__u8e3s4, len, $completion), charset);
}
function *readU16BE(_this__u8e3s4, $completion) {
  // Inline function 'korlibs.io.stream.readSmallTempExact' call
  var it = new Int8Array(2);
  var read = yield* _this__u8e3s4.kb6(it, 0, 2, $completion);
  if (!(read === 2)) {
    // Inline function 'kotlin.error' call
    var message = "Couldn't read exact size=" + 2 + ' but read=' + read;
    throw IllegalStateException.o(toString(message));
  }
  return getU16BE(it, 0);
}
function *readU16(_this__u8e3s4, endian, $completion) {
  return endian.equals(Endian_LITTLE_ENDIAN_getInstance()) ? (yield* readU16LE(_this__u8e3s4, $completion)) : (yield* /*#__NOINLINE__*/readU16BE(_this__u8e3s4, $completion));
}
function *readS32(_this__u8e3s4, endian, $completion) {
  return endian.equals(Endian_LITTLE_ENDIAN_getInstance()) ? (yield* /*#__NOINLINE__*/readS32LE(_this__u8e3s4, $completion)) : (yield* readS32BE(_this__u8e3s4, $completion));
}
function *readStringz(_this__u8e3s4, len, charset, $completion) {
  charset = charset === VOID ? get_UTF8() : charset;
  var res = yield* readBytesExact(_this__u8e3s4, len, $completion);
  var index = indexOf(res, 0);
  return toString_1(copyOf(res, index < 0 ? len : index), charset);
}
function *readLine(_this__u8e3s4, eol, charset, limit, initialCapacity, includeEnd, $completion) {
  eol = eol === VOID ? _Char___init__impl__6a9atx(10) : eol;
  charset = charset === VOID ? get_UTF8() : charset;
  limit = limit === VOID ? 2147483647 : limit;
  initialCapacity = initialCapacity === VOID ? 4096 : initialCapacity;
  includeEnd = includeEnd === VOID ? false : includeEnd;
  // Inline function 'kotlin.code' call
  var tmp$ret$0 = Char__toInt_impl_vasixd(eol);
  return toString_1(yield* readUntil(_this__u8e3s4, toByte(tmp$ret$0), limit, initialCapacity, includeEnd, VOID, $completion), charset);
}
function *readS32BE(_this__u8e3s4, $completion) {
  // Inline function 'korlibs.io.stream.readSmallTempExact' call
  var it = new Int8Array(4);
  var read = yield* _this__u8e3s4.kb6(it, 0, 4, $completion);
  if (!(read === 4)) {
    // Inline function 'kotlin.error' call
    var message = "Couldn't read exact size=" + 4 + ' but read=' + read;
    throw IllegalStateException.o(toString(message));
  }
  return getS32BE(it, 0);
}
function *readU16LE(_this__u8e3s4, $completion) {
  // Inline function 'korlibs.io.stream.readSmallTempExact' call
  var it = new Int8Array(2);
  var read = yield* _this__u8e3s4.kb6(it, 0, 2, $completion);
  if (!(read === 2)) {
    // Inline function 'kotlin.error' call
    var message = "Couldn't read exact size=" + 2 + ' but read=' + read;
    throw IllegalStateException.o(toString(message));
  }
  return getU16LE(it, 0);
}
function *readUntil(_this__u8e3s4, endByte, limit, initialCapacity, includeEnd, temp, $completion) {
  limit = limit === VOID ? 2147483647 : limit;
  initialCapacity = initialCapacity === VOID ? 4096 : initialCapacity;
  includeEnd = includeEnd === VOID ? false : includeEnd;
  temp = temp === VOID ? new Int8Array(1) : temp;
  var out = ByteArrayBuilder.taz(initialCapacity);
  try {
    $l$loop_0: while (true) {
      yield* readExact(_this__u8e3s4, temp, 0, 1, $completion);
      var c = temp[0];
      if (c === endByte) {
        if (includeEnd) {
          // Inline function 'korlibs.memory.ByteArrayBuilder.append' call
          out.waz(c);
        }
        break $l$loop_0;
      }
      // Inline function 'korlibs.memory.ByteArrayBuilder.append' call
      out.waz(c);
      if (out.s2() >= limit)
        break $l$loop_0;
    }
  } catch ($p) {
    if ($p instanceof EOFException) {
      var e = $p;
    } else {
      throw $p;
    }
  }
  return out.xaz();
}
function skipToAlign(_this__u8e3s4, alignment, offset) {
  var tmp = _this__u8e3s4;
  // Inline function 'kotlin.Long.plus' call
  var this_0 = _this__u8e3s4.yb8_1;
  var tmp$ret$0 = add(this_0, fromInt(offset));
  // Inline function 'kotlin.Long.minus' call
  var this_1 = nextAlignedTo(tmp$ret$0, fromInt(alignment));
  tmp.yb8_1 = subtract(this_1, fromInt(offset));
}
function *readBytes(_this__u8e3s4, position, count, $completion) {
  var out = new Int8Array(count);
  var readLen = yield* _this__u8e3s4.nb8(position, out, 0, out.length, $completion);
  return copyOf(out, readLen);
}
function *readStream(_this__u8e3s4, length, $completion) {
  return yield* readSlice(_this__u8e3s4, fromInt(length), $completion);
}
function *sliceStart(_this__u8e3s4, start, closeParent, $completion) {
  start = start === VOID ? new Long(0, 0) : start;
  closeParent = closeParent === VOID ? false : closeParent;
  return yield* sliceWithBounds(_this__u8e3s4, start, yield* _this__u8e3s4.pb8($completion), closeParent, $completion);
}
function *sliceHere(_this__u8e3s4, closeParent, $completion) {
  closeParent = closeParent === VOID ? false : closeParent;
  return yield* sliceWithSize(_this__u8e3s4, _this__u8e3s4.yb8_1, yield* _this__u8e3s4.pb8($completion), closeParent, $completion);
}
function *readSlice(_this__u8e3s4, length, $completion) {
  var start = yield* _this__u8e3s4.tb8($completion);
  var out = yield* sliceWithSize(_this__u8e3s4, start, length, VOID, $completion);
  yield* _this__u8e3s4.cb9(add(start, length), $completion);
  return out;
}
function *sliceWithBounds(_this__u8e3s4, start, end, closeParent, $completion) {
  closeParent = closeParent === VOID ? false : closeParent;
  var rlen = (yield* _this__u8e3s4.qb8($completion)) ? (yield* _this__u8e3s4.pb8($completion)) : end;
  var len = compare(rlen, new Long(0, 0)) >= 0 ? rlen : end;
  var clampedStart = coerceIn_0(start, new Long(0, 0), len);
  var clampedEnd = coerceIn_0(end, new Long(0, 0), len);
  var base = _this__u8e3s4.xb8_1;
  var tmp;
  if (base instanceof SliceAsyncStreamBase) {
    tmp = SliceAsyncStreamBase.ib9(base.db9_1, add(base.eb9_1, clampedStart), add(base.eb9_1, clampedEnd), closeParent);
  } else {
    tmp = SliceAsyncStreamBase.ib9(_this__u8e3s4.xb8_1, clampedStart, clampedEnd, closeParent);
  }
  return toAsyncStream(tmp);
}
function *sliceWithSize(_this__u8e3s4, start, length, closeParent, $completion) {
  closeParent = closeParent === VOID ? false : closeParent;
  return yield* /*#__NOINLINE__*/sliceWithBounds(_this__u8e3s4, start, add(start, length), closeParent, $completion);
}
function clampPosition($this, position) {
  return coerceIn_0(position, $this.eb9_1, $this.fb9_1);
}
function clampPositionLen($this, position, len) {
  if (compare(position, new Long(0, 0)) < 0)
    throw IllegalArgumentException.h2('Invalid position');
  var targetStartPosition = clampPosition($this, add($this.eb9_1, position));
  // Inline function 'kotlin.Long.plus' call
  var tmp$ret$0 = add(targetStartPosition, fromInt(len));
  var targetEndPosition = clampPosition($this, tmp$ret$0);
  var targetLen = convertToInt(subtract(targetEndPosition, targetStartPosition));
  return new Pair(targetStartPosition, targetLen);
}
function buffered(_this__u8e3s4, blockSize, blocksToRead) {
  blockSize = blockSize === VOID ? 2048 : blockSize;
  blocksToRead = blocksToRead === VOID ? 16 : blocksToRead;
  return toAsyncStream(BufferedStreamBase.pb9(_this__u8e3s4.xb8_1, blockSize, blocksToRead), _this__u8e3s4.yb8_1);
}
function openAsync(_this__u8e3s4, mode) {
  mode = mode === VOID ? 'r' : mode;
  return toAsyncStream(MemoryAsyncStreamBase.ib8(ByteArrayBuilder.saz(_this__u8e3s4, VOID, true)), new Long(0, 0));
}
function *readInternal($this, buffer, offset, len, $completion) {
  var read = yield* $this.xb8_1.nb8($this.yb8_1, buffer, offset, len, $completion);
  if (read >= 0) {
    var tmp = $this;
    // Inline function 'kotlin.Long.plus' call
    var this_0 = $this.yb8_1;
    tmp.yb8_1 = add(this_0, fromInt(read));
  }
  return read;
}
function *writeInternal($this, buffer, offset, len, $completion) {
  yield* $this.xb8_1.ob8($this.yb8_1, buffer, offset, len, $completion);
  var tmp = $this;
  // Inline function 'kotlin.Long.plus' call
  var this_0 = $this.yb8_1;
  tmp.yb8_1 = add(this_0, fromInt(len));
  return Unit_instance;
}
function *readBytesUpTo(_this__u8e3s4, len, $completion) {
  var BYTES_TEMP_SIZE = 4096;
  if (len <= BYTES_TEMP_SIZE)
    return yield* readBytesUpToCopy(_this__u8e3s4, new Int8Array(len), $completion);
  if (isInterface(_this__u8e3s4, AsyncPositionLengthStream)) {
    // Inline function 'kotlin.math.min' call
    var b = toIntClamp(yield* _this__u8e3s4.wb9($completion));
    var tmp$ret$0 = Math.min(len, b);
    return yield* readBytesUpToCopy(_this__u8e3s4, new Int8Array(tmp$ret$0), $completion);
  }
  var pending = len;
  var temp = new Int8Array(BYTES_TEMP_SIZE);
  var bout = ByteArrayBuilder.taz();
  $l$loop: while (pending > 0) {
    var tmp0 = temp.length;
    // Inline function 'kotlin.math.min' call
    var b_0 = pending;
    var tmp$ret$1 = Math.min(tmp0, b_0);
    var read = yield* _this__u8e3s4.kb6(temp, 0, tmp$ret$1, $completion);
    if (read <= 0)
      break $l$loop;
    bout.uaz(temp, 0, read);
    pending = pending - read | 0;
  }
  return bout.xaz();
}
function *readBytesExact(_this__u8e3s4, len, $completion) {
  // Inline function 'kotlin.apply' call
  var this_0 = new Int8Array(len);
  yield* readExact(_this__u8e3s4, this_0, 0, len, $completion);
  return this_0;
}
function *readBytesUpTo_0(_this__u8e3s4, out, offset, len, $completion) {
  var total = 0;
  var pending = len;
  var offset_0 = offset;
  $l$loop: while (true) {
    var result = yield* _this__u8e3s4.kb6(out, offset_0, pending, $completion);
    if (result <= 0)
      break $l$loop;
    offset_0 = offset_0 + result | 0;
    pending = pending - result | 0;
    total = total + result | 0;
  }
  return total;
}
function *readAll(_this__u8e3s4, $completion) {
  var tmp;
  try {
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (isInterface(_this__u8e3s4, AsyncGetPositionStream)) {
      tmp_2 = isInterface(_this__u8e3s4, AsyncGetLengthStream);
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = yield* _this__u8e3s4.qb8($completion);
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      var available = subtract(yield* _this__u8e3s4.pb8($completion), yield* _this__u8e3s4.tb8($completion));
      tmp_0 = yield* /*#__NOINLINE__*/readBytesExact(_this__u8e3s4, convertToInt(available), $completion);
    } else {
      var tmp_3;
      if (_this__u8e3s4 instanceof AsyncStream) {
        tmp_3 = yield* _this__u8e3s4.vb9($completion);
      } else {
        tmp_3 = false;
      }
      if (tmp_3) {
        var available_0 = convertToInt(yield* _this__u8e3s4.wb9($completion));
        tmp_0 = yield* /*#__NOINLINE__*/readBytesExact(_this__u8e3s4, available_0, $completion);
      } else {
        var out = ByteArrayBuilder.taz();
        // Inline function 'korlibs.io.stream.readChunks' call
        var temp = new Int8Array(1024);
        $l$loop: while (true) {
          var r = yield* _this__u8e3s4.kb6(temp, 0, temp.length, $completion);
          if (r <= 0)
            break $l$loop;
          out.uaz(temp, 0, r);
        }
        tmp_0 = out.xaz();
      }
    }
    tmp = tmp_0;
  }finally {
    yield* _this__u8e3s4.lb6($completion);
  }
  return tmp;
}
function toAsyncStream(_this__u8e3s4, position) {
  position = position === VOID ? new Long(0, 0) : position;
  return new AsyncStream(_this__u8e3s4, position);
}
function *readExact(_this__u8e3s4, buffer, offset, len, $completion) {
  var remaining = len;
  var coffset = offset;
  var reader = _this__u8e3s4;
  $l$loop: while (remaining > 0) {
    var read = yield* reader.kb6(buffer, coffset, remaining, $completion);
    if (read < 0)
      break $l$loop;
    if (read === 0)
      throw EOFException.wb1('Not enough data. Expected=' + len + ', Read=' + (len - remaining | 0) + ', Remaining=' + remaining);
    coffset = coffset + read | 0;
    remaining = remaining - read | 0;
  }
  return Unit_instance;
}
function *readBytesUpToCopy(_this__u8e3s4, out, $completion) {
  var pos = yield* /*#__NOINLINE__*/readBytesUpTo_0(_this__u8e3s4, out, 0, out.length, $completion);
  return out.length === pos ? out : copyOf(out, pos);
}
function *asyncStreamWriter(bufferSize, name, lazy, process, $completion) {
  bufferSize = bufferSize === VOID ? 8388608 : bufferSize;
  name = name === VOID ? null : name;
  lazy = lazy === VOID ? false : lazy;
  return new asyncStreamWriter$2(lazy, bufferSize, name, process);
}
function checkException($this) {
  if (!($this.zb9_1 == null))
    throw RuntimeException.qe('Error in asyncStreamWriter : ' + toString_0($this.zb9_1), ensureNotNull($this.zb9_1));
}
function *ensureJob($this, $completion) {
  if (!($this.aba_1 == null))
    return Unit_instance;
  var tmp = $this;
  // Inline function 'kotlin.js.getCoroutineContext' call
  var tmp$ret$0 = $completion.od();
  var tmp_0 = CoroutineScope(tmp$ret$0);
  tmp.aba_1 = launch(tmp_0, VOID, VOID, asyncStreamWriter$o$ensureJob$slambda($this.cba_1, $this));
  return Unit_instance;
}
function asyncStreamWriter$o$ensureJob$slambda($process, this$0) {
  return constructCallableReference(function *($this$launch, $completion) {
    var tmp;
    try {
      tmp = yield* $process(new asyncStreamWriter$2$ensureJob$2$1(this$0), $completion);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        this$0.zb9_1 = e;
        printStackTrace(e);
        tmp_0 = Unit_instance;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    finally {
      yield* this$0.yb9_1.lb6($completion);
    }
    return Unit_instance;
  }, 1);
}
function toSyncStream(_this__u8e3s4) {
  return ReadonlySyncStreamBase.iba(_this__u8e3s4.rb6_1, _this__u8e3s4.sb6_1, _this__u8e3s4.tb6_1 - _this__u8e3s4.sb6_1 | 0).jba();
}
function MemorySyncStream(data) {
  data = data === VOID ? get_EMPTY_BYTE_ARRAY() : data;
  return MemorySyncStreamBase.gb8(ByteArrayBuilder.saz(data)).oba();
}
function openSync(_this__u8e3s4, mode) {
  mode = mode === VOID ? 'r' : mode;
  return MemorySyncStreamBase.gb8(ByteArrayBuilder.saz(_this__u8e3s4)).nba(new Long(0, 0));
}
function MemorySyncStream_0(data) {
  return MemorySyncStreamBase.gb8(data).oba();
}
function readString_0(_this__u8e3s4, len) {
  return decodeToString(readBytes_0(_this__u8e3s4, len));
}
function readS32BE_0(_this__u8e3s4) {
  return readU8(_this__u8e3s4) << 24 | readU8(_this__u8e3s4) << 16 | readU8(_this__u8e3s4) << 8 | readU8(_this__u8e3s4);
}
function readStringz_0(_this__u8e3s4, len) {
  var res = readBytes_0(_this__u8e3s4, len);
  var index = indexOf(res, 0);
  return decodeToString(copyOf(res, index < 0 ? len : index));
}
function readU8(_this__u8e3s4) {
  return _this__u8e3s4.k2k();
}
function readString_1(_this__u8e3s4, len, charset) {
  charset = charset === VOID ? get_UTF8() : charset;
  return toString_1(readBytes_0(_this__u8e3s4, len), charset);
}
function readBytes_0(_this__u8e3s4, len) {
  var bytes = new Int8Array(len);
  var out = _this__u8e3s4.ob3(bytes, 0, len);
  return !(out === len) ? copyOf(bytes, out) : bytes;
}
function write8(_this__u8e3s4, v) {
  return _this__u8e3s4.vba(v);
}
function get_eof(_this__u8e3s4) {
  return compare(_this__u8e3s4.ab5(), new Long(0, 0)) <= 0;
}
function readAll_0(_this__u8e3s4) {
  return readBytes_0(_this__u8e3s4, convertToInt(_this__u8e3s4.ab5()));
}
function readStream_0(_this__u8e3s4, length) {
  return readSlice_0(_this__u8e3s4, length);
}
function sliceStart_0(_this__u8e3s4, start) {
  start = start === VOID ? new Long(0, 0) : start;
  return sliceWithBounds_0(_this__u8e3s4, start, _this__u8e3s4.a());
}
function readSlice_0(_this__u8e3s4, length) {
  // Inline function 'kotlin.apply' call
  var this_0 = sliceWithSize_0(_this__u8e3s4, _this__u8e3s4.wb6(), length);
  _this__u8e3s4.rba(add(_this__u8e3s4.wb6(), length));
  return this_0;
}
function sliceWithBounds_0(_this__u8e3s4, start, end) {
  var len = _this__u8e3s4.a();
  var clampedStart = coerceIn_0(start, new Long(0, 0), len);
  var clampedEnd = coerceIn_0(end, new Long(0, 0), len);
  var base = _this__u8e3s4.ub7_1;
  if (base instanceof SliceSyncStreamBase) {
    return SliceSyncStreamBase.bbb(base.xba_1, add(base.yba_1, clampedStart), add(base.yba_1, clampedEnd)).oba();
  } else {
    return SliceSyncStreamBase.bbb(base, clampedStart, clampedEnd).oba();
  }
}
function sliceWithSize_0(_this__u8e3s4, position, length) {
  return sliceWithBounds_0(_this__u8e3s4, position, add(position, length));
}
function clampPosition_0($this, position) {
  return coerceIn_0(position, $this.yba_1, $this.zba_1);
}
function clampPositionLen_0($this, position, len) {
  if (compare(position, new Long(0, 0)) < 0)
    throw IllegalArgumentException.h2('Invalid position');
  var targetStartPosition = clampPosition_0($this, add($this.yba_1, position));
  // Inline function 'kotlin.Long.plus' call
  var tmp$ret$0 = add(targetStartPosition, fromInt(len));
  var targetEndPosition = clampPosition_0($this, tmp$ret$0);
  var targetLen = convertToInt(subtract(targetEndPosition, targetStartPosition));
  return new Pair(targetStartPosition, targetLen);
}
//region block: post-declaration
initMetadataForInterface(AsyncOutputStream, 'AsyncOutputStream', VOID, VOID, VOID, [3, 1, 0]);
protoOf(AsyncRingBuffer).jb6 = write$default;
initMetadataForClass(AsyncRingBuffer, 'AsyncRingBuffer', AsyncRingBuffer, VOID, [AsyncOutputStream], [3, 0, 1]);
initMetadataForCompanion(Companion);
protoOf(AsyncRingBufferChunked).jb6 = write$default;
initMetadataForClass(AsyncRingBufferChunked, 'AsyncRingBufferChunked', AsyncRingBufferChunked, VOID, [AsyncOutputStream], [1, 3, 0]);
initMetadataForClass(FastByteArrayInputStream, 'FastByteArrayInputStream');
initMetadataForInterface(AsyncGetLengthStream, 'AsyncGetLengthStream', VOID, VOID, VOID, [0]);
protoOf(AsyncStreamBase).qb8 = hasLength;
initMetadataForClass(AsyncStreamBase, 'AsyncStreamBase', AsyncStreamBase.mb8, VOID, [AsyncGetLengthStream], [4, 1, 0]);
initMetadataForClass(SyncAsyncStreamBase, 'SyncAsyncStreamBase', VOID, VOID, VOID, [1, 4, 0]);
initMetadataForInterface(AsyncGetPositionStream, 'AsyncGetPositionStream', VOID, VOID, VOID, [0]);
protoOf(toAsync$1).qb8 = hasLength;
initMetadataForClass(toAsync$1, VOID, VOID, VOID, [AsyncGetPositionStream, AsyncGetLengthStream], [1, 3, 0]);
protoOf(toAsync$2).jb6 = write$default;
initMetadataForClass(toAsync$2, VOID, VOID, VOID, [AsyncOutputStream], [1, 3, 0]);
initMetadataForClass(SliceAsyncStreamBase, 'SliceAsyncStreamBase', VOID, VOID, VOID, [4, 0, 1]);
initMetadataForClass(BufferedStreamBase, 'BufferedStreamBase', VOID, VOID, VOID, [4, 1, 0]);
initMetadataForClass(MemoryAsyncStreamBase, 'MemoryAsyncStreamBase', MemoryAsyncStreamBase.rb9, VOID, VOID, [1, 0, 4]);
initMetadataForInterface(AsyncPositionLengthStream, 'AsyncPositionLengthStream', VOID, VOID, [AsyncGetPositionStream, AsyncGetLengthStream], [0, 1]);
protoOf(AsyncStream).jb6 = write$default;
protoOf(AsyncStream).vb9 = hasAvailable;
protoOf(AsyncStream).wb9 = getAvailable;
protoOf(AsyncStream).xb9 = eof;
initMetadataForClass(AsyncStream, 'AsyncStream', VOID, VOID, [AsyncGetPositionStream, AsyncGetLengthStream, AsyncOutputStream, AsyncPositionLengthStream], [3, 0, 1]);
protoOf(asyncStreamWriter$2$ensureJob$2$1).jb6 = write$default;
initMetadataForClass(asyncStreamWriter$2$ensureJob$2$1, VOID, VOID, VOID, [AsyncOutputStream], [3, 1, 0]);
initMetadataForClass(asyncStreamWriter$2, VOID, VOID, VOID, VOID, [0, 3]);
initMetadataForInterface(SyncLengthStream, 'SyncLengthStream');
initMetadataForClass(SyncStreamBase, 'SyncStreamBase', SyncStreamBase.kba, VOID, [AutoCloseable, SyncLengthStream]);
initMetadataForClass(ReadonlySyncStreamBase, 'ReadonlySyncStreamBase');
initMetadataForClass(MemorySyncStreamBase, 'MemorySyncStreamBase', MemorySyncStreamBase.pba);
initMetadataForInterface(SyncInputStream, 'SyncInputStream', VOID, VOID, [AutoCloseable]);
initMetadataForInterface(SyncPositionStream, 'SyncPositionStream');
initMetadataForInterface(SyncOutputStream, 'SyncOutputStream', VOID, VOID, [AutoCloseable]);
initMetadataForClass(SyncStream, 'SyncStream', VOID, VOID, [AutoCloseable, SyncInputStream, SyncPositionStream, SyncOutputStream, SyncLengthStream]);
initMetadataForClass(SliceSyncStreamBase, 'SliceSyncStreamBase');
//endregion
//region block: init
Companion_instance = new Companion();
//endregion
//region block: exports
export {
  asyncStreamWriter as asyncStreamWriter38isk6dcvpewr,
  readAll as readAll1k0zte4qdypit,
  readBytesExact as readBytesExact9lk5ofbmnwn5,
  readBytesUpTo as readBytesUpTo3v2pxuza3qdby,
  readBytesUpTo_0 as readBytesUpToeg5gy13toqtd,
  readLine as readLine1qo67k5yfh94w,
  readS16LE as readS16LE5ndf91ig7ujq,
  readS32LE as readS32LE1s59z1zzhuc7p,
  readS32 as readS32mmpqk5mai7ic,
  readStream as readStream37xep802rz21z,
  readStringz as readStringz1nu1lc3nd8jc7,
  readString as readString2gn2js5u0onhc,
  readU16 as readU163iaqmopzplujm,
  readU32LE as readU32LE1krwiht3byo6m,
  sliceHere as sliceHere46mgk3n9huns,
  sliceStart as sliceStartd2tqagpdmlnp,
  write$default as write$default3v2dul172q0c3,
  AsyncGetLengthStream as AsyncGetLengthStream219k26r6v6js2,
  AsyncGetPositionStream as AsyncGetPositionStream2f8n5516y4rp7,
  AsyncOutputStream as AsyncOutputStreamkoco1dsjo5gm,
  AsyncStreamBase as AsyncStreamBaseze8sfl15nwf0,
  FastByteArrayInputStream as FastByteArrayInputStream1jjm4ufd0tkh5,
  MemorySyncStream as MemorySyncStreamw5bwb9yy0cam,
  MemorySyncStream_0 as MemorySyncStream1uv927me2xl9s,
  buffered as buffered29ldm4q6ez2xm,
  get_eof as get_eofaukbsoaf5jcj,
  openAsync as openAsync37anb1e84urmo,
  openFastStream as openFastStream2r4uuohoj0wpo,
  openSync as openSync2m3qn99fqytu0,
  readAll_0 as readAll3m5rixujsbctr,
  readBytes_0 as readBytes3l26albs0coyl,
  readS32BE_0 as readS32BE1vkzsiuy9pof1,
  readStream_0 as readStream3s64ivrsklqly,
  readStringz_0 as readStringz3jxaogr49n5ys,
  readString_0 as readString20u8kjncp0xlx,
  readString_1 as readString3106ot9qwcir2,
  readU8 as readU82o15i0epsnmc5,
  skipToAlign as skipToAlignusebk6ndjvs1,
  sliceStart_0 as sliceStart237tx6t7cytus,
  toAsyncStream as toAsyncStream3ow20wz4trxzb,
  toAsync_0 as toAsync26jtc2k5wi4gn,
  toAsync_1 as toAsync2pa2d6thtq8t4,
  toAsync as toAsyncc87ncfb6nti7,
  toSyncOrNull as toSyncOrNull2d7etdx5kh7ns,
  toSyncStream as toSyncStream3g0dpktigjx33,
  write8 as write81fg3kayjaelgo,
};
//endregion
